import { render, staticRenderFns } from "./NotificationPanel.vue?vue&type=template&id=0a2876a2&scoped=true"
import script from "./NotificationPanel.vue?vue&type=script&lang=js"
export * from "./NotificationPanel.vue?vue&type=script&lang=js"
import style0 from "./NotificationPanel.vue?vue&type=style&index=0&id=0a2876a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2876a2",
  null
  
)

export default component.exports